<template>
  <div class="login_bg _col_center" id="login">
    <div class="bg_img">
      <img
        src="@/assets/img/login_bg/homepage_bg.png"
        alt=""
        srcset=""
        style="width: 100%; height: 100%"
      />
    </div>
    <div class="login_box _row_between">
      <img
        src="@/assets/img/login_bg/homepage_bg2.png"
        alt=""
        title=""
        srcset=""
        style="width: 46%; margin-left: 3%; padding: 2% 0"
      />
      <div class="form_box _col">
        <div class="top_title">
          <p class="font28 color_blue">{{ $t("lang.设置新的登录密码") }}</p>
          <p class="text1">
            {{ $t("lang.首次登录用户为了您帐户的安全请先重设您的登录密码") }}
          </p>
        </div>
        <el-form
          style="width: 70%"
          :model="loginForm"
          :rules="loginFormRules"
          ref="loginFormRef"
          class="icon_set"
        >
          <el-form-item prop="password" class="mb46">
            <el-input
              v-model="loginForm.password"
              :type="eyes.open1 ? 'text' : 'password'"
              :placeholder="$t('lang.请输入新密码')"
              @keyup.enter.native="onClickLogin"
            >
              <i
                slot="prefix"
                class="icon-mima1 iconfont"
                style="color: #d7dee3; font-size: 24px"
              ></i>
              <i
                slot="suffix"
                v-if="eyes.open1"
                class="icon-xianshi iconfont"
                @click="eyes.open1 = false"
                style="color: #d7dee3; font-size: 24px"
              ></i>
              <i
                slot="suffix"
                v-else
                class="icon-yincang iconfont"
                @click="eyes.open1 = true"
                style="color: #d7dee3; font-size: 24px"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="passwordRe" class="mb20">
            <el-input
              v-model="loginForm.passwordRe"
              :type="eyes.open2 ? 'text' : 'password'"
              :placeholder="$t('lang.请再次输入新密码')"
              @keyup.enter.native="onClickLogin"
            >
              <i
                slot="prefix"
                class="icon-mima1 iconfont"
                style="color: #d7dee3; font-size: 24px"
              ></i>
              <i
                slot="suffix"
                v-if="eyes.open2"
                class="icon-xianshi iconfont"
                @click="eyes.open2 = false"
                style="color: #d7dee3; font-size: 24px"
              ></i>
              <i
                slot="suffix"
                v-else
                class="icon-yincang iconfont"
                @click="eyes.open2 = true"
                style="color: #d7dee3; font-size: 24px"
              ></i>
            </el-input>
          </el-form-item>
          <p class="text2">
            {{
              $t("lang.密码长度必须限制为620个字符并且使用至少1个字母和1个数字")
            }}
          </p>
          <el-form-item class="btns">
            <el-button
              type="primary"
              @click="onClickLogin"
              :loading="loading"
              >{{ $t("lang.登录") }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <ContactModule/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ContactModule from "./contact-module.vue";
const letterAndDigit = /^(?=.*[a-zA-Z])(?=.*[0-9]).*$/;
export default {
  components: {
    ContactModule,
  },
  name: "LoginResetPwd",
  data() {
    //#region 校验规则
    var valiPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lang.请输入新密码")));
      } else if (value.length < 6) {
        callback(new Error(this.$t("lang.密码长度不能小于6位")));
      } else if (value.length > 20) {
        callback(new Error(this.$t("lang.密码长度不能大于20位")));
      } else if (!letterAndDigit.test(value)) {
        callback(new Error(this.$t("lang.密码至少包含1个字母和1个数字")));
      } else {
        callback();
      }
    };
    var valiPwdRe = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lang.请再次输入新密码")));
      } else if (value.length < 6) {
        callback(new Error(this.$t("lang.密码长度不能小于6位")));
      } else if (value.length > 20) {
        callback(new Error(this.$t("lang.密码长度不能大于20位")));
      } else if (!letterAndDigit.test(value)) {
        callback(new Error(this.$t("lang.密码至少包含1个字母和1个数字")));
      } else if (this.loginForm.password !== value) {
        callback(new Error(this.$t("lang.输入密码不一致")));
      } else {
        callback();
      }
    };
    //#endregion
    return {
      eyes: {
        open1: false,
        open2: false,
      },
      loading: false,
      loginForm: {
        password: "",
        passwordRe: "",
      },
      loginFormRules: {
        password: [{ validator: valiPwd, trigger: "blur" }],
        passwordRe: [{ validator: valiPwdRe, trigger: "blur" }],
      },
    };
  },
  created() {},
  methods: {
    ...mapActions({
      pwdUpdate: "ZD_DoLoginPasswordUpdate",
      loginInV1: "ZD_LoginInV1",
    }),
    //第一次调用统一平台登入接口
    async onClickLogin() {
      try {
        await this.$refs["loginFormRef"].validate();
        this.loading = true;
        this.loginForm.successCheckType = 1;
        //充值密码
        const res = await this.pwdUpdate({
          value: {
            newPassword: this.loginForm.password,
          },
        });
        if (res.success !== 1) return;
        //片区登录
        const loginRes = await this.loginInV1({});
        if (loginRes.success !== 1) return;
        this.$router.push("/deviceList");
        setTimeout(() => {
          this.$message({
            message: this.$t("lang.登录成功"),
            type: "success",
          });
        }, 300);
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.reset_password {
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  .title {
    font-size: 29px;
    color: #409eff;
    margin-bottom: 10px;
  }
  .text1 {
    font-size: 14px;
    color: #999999;
  }
  .input_icon {
    color: #d7dee3;
    font-size: 24px;
  }
}
.icon_set {
  position: relative;
  padding-top: 48px;
  .icons {
    display: flex;
    align-items: center;
    .code {
      display: inline-block;
      padding-left: 18px;
      padding-right: 12px;
      font-size: 16px;
      color: #409eff;
      cursor: pointer;
    }
  }
  .text2 {
    font-size: 12px;
    color: #999;
    margin-bottom: 58px;
  }
}
a {
  cursor: pointer;
}
#login {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.login_box {
  position: relative;
  width: 65%;
  background: white;
  position: absolute;
  border-radius: 10px;
  z-index: 1;
  .login_box_top {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -40%);
    display: flex;
    align-items: center;
    flex-direction: column;
    .avatar_box {
      width: 130px;
      height: 130px;
      border: 1px solid #eee;
      border-radius: 50%;
      padding: 10px;
      box-shadow: 0 0 10px #eee;
      background: rgb(250, 250, 250);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      img {
        width: 53.7%;
        height: 80%;
      }
    }
  }
}
.form_box {
  width: 70%;
  .top_title {
    width: 70%;
    text-align: left;
    margin-top: 7%;
    .text1 {
      font-size: 14px;
      color: #999999;
      margin-top: 10px;
    }
  }
}
.btns {
  display: flex;
  justify-content: center;
  /deep/ .el-button {
    font-size: 15px;
    width: 292px;
    height: 40px;
    background: #409eff;
    border-radius: 6px;
  }
}
.login_container {
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.login_bg {
  width: 100%;
  height: 100%;
  position: relative;
}
.bg_img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  right: 0px;
}
.login_box_inner {
  margin: 60px 0px;
  padding: 0 30px;
}
.login_agree_text {
  font-size: 12px;
  color: #999;
}
.login_agree_article {
  font-size: 12px;
  color: #999;
  cursor: pointer;
}
.login_agree_article :hover {
  color: rgb(0, 0, 0);
}
.login_bottom {
  margin-bottom: 8%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .el-input__inner {
  border-radius: 0 4px 4px 0;
  border-bottom: 1px solid #ccc;
  border-top: none;
  border-left: none;
  border-right: none;
  color: #333;
  font-size: 16px;
  padding-left: 45px;
  padding-bottom: 10px;
}
/deep/.el-checkbox__label {
  color: #c1c9ce;
}
.icon_user {
  font-size: 26px;
  color: #d7dee3;
}
.mb46 {
  margin-bottom: 46px;
}
.mb20 {
  margin-bottom: 20px;
}
</style>
